import { render, staticRenderFns } from "./FFContextMenu.vue?vue&type=template&id=81551e76&scoped=true&"
import script from "./FFContextMenu.vue?vue&type=script&lang=js&"
export * from "./FFContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./FFContextMenu.vue?vue&type=style&index=0&id=81551e76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81551e76",
  null
  
)

export default component.exports